module.exports = __webpack_public_path__ + "static/media/laptop@2x.0091a24f.png";